import React, { useState, useEffect } from "react";
import { Table, Form, Button, Badge, InputGroup, Card } from 'react-bootstrap';
import { busca_pente_fino } from "../../services/api";
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';

const PenteFinoCarteirinhas = (props) => {
    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];
    const unidades_sigla = ['', 'BR', 'MD', 'SC', 'CD', 'TQ', 'NP', '', '', 'SP', 'BT', 'CG', 'CP', 'MG', 'MC', 'IG', 'FG', 'RB'];

    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const meu_perfil = perfil[0]?.perfil || "";

    let unidadesPermitidas = [];
    if (meu_perfil === "GESTOR") {
        unidadesPermitidas = unidades_sigla.map((_, i) => i).filter(i => i > 0 && unidades_sigla[i]);
    } else if (meu_perfil.startsWith("DIRETOR") || meu_perfil.startsWith("SECRETARIA")) {
        const numerosString = meu_perfil.replace(/DIRETOR|SECRETARIA/, "").trim();
        unidadesPermitidas = numerosString.split("-").map(n => parseInt(n));
    }

    // Estados
    const [listaAlunos, setListaAlunos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [unidadeFiltro, setUnidadeFiltro] = useState(unidadesPermitidas.length === 1 ? unidadesPermitidas[0].toString().padStart(2, '0') : "");
    const [anoFiltro, setAnoFiltro] = useState("26");
    const [buscaTexto, setBuscaTexto] = useState("");
    const [statusFiltro, setStatusFiltro] = useState("TODOS"); // Novo estado para filtro de status

    useEffect(() => {
        if (unidadesPermitidas.length === 1) {
            handleBuscar(unidadesPermitidas[0].toString().padStart(2, '0'));
        }
    }, []);

    const handleBuscar = async (unidadeForcada = null) => {
        const unidadeAlvo = unidadeForcada || unidadeFiltro;
        if (!unidadeAlvo) { alert("Selecione uma unidade"); return; }

        setLoading(true);
        try {
            const data = await busca_pente_fino(unidadeAlvo, anoFiltro);
            setListaAlunos(data);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
            setListaAlunos([]);
        } finally {
            setLoading(false);
        }
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Conferida e usada': return <Badge bg="success">Conferida e usada</Badge>;
            case 'Conferida mas nunca usada': return <Badge bg="warning" text="dark">Conferida mas nunca usada</Badge>;
            case 'Inconsistência: Uso sem conferência': return <Badge bg="danger">Uso sem conferência</Badge>;
            case 'Pedido em aberto (Não entregue)': return <Badge bg="info" text="dark">Pedido em aberto</Badge>;
            case 'Sem registro de pedido no sistema': return <Badge bg="secondary">Sem pedido</Badge>;
            default: return <Badge bg="light" text="dark">{status}</Badge>;
        }
    };

    // Lógica de Filtragem (Texto + Status)
    const dadosFiltrados = listaAlunos.filter(item => {
        const correspondeTexto = item.nome.toLowerCase().includes(buscaTexto.toLowerCase()) ||
            item.matricula.includes(buscaTexto) ||
            item.turma.toLowerCase().includes(buscaTexto.toLowerCase());

        const correspondeStatus = statusFiltro === "TODOS" || item.status_final === statusFiltro;

        return correspondeTexto && correspondeStatus;
    });

    return (
        <div className="p-4" style={{ marginBottom: '60px' }}>
            <Navbar expand="lg" className="bg-body-tertiary">

                <Navbar.Brand href="/">Santa Mônica Rede de Ensino</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </Navbar>
            <Card className="mb-4 shadow-sm">
                <Card.Body>
                    <Card.Title className="mb-4 text-primary">Auditoria de Carteirinhas Estudantis - 6º Ano até 3ª Série</Card.Title>
                    <Form>
                        <div className="row g-3">
                            <div className="col-md-3">
                                <Form.Label>Unidade</Form.Label>
                                <Form.Select
                                    value={unidadeFiltro}
                                    onChange={(e) => setUnidadeFiltro(e.target.value)}
                                    disabled={unidadesPermitidas.length === 1}
                                >
                                    <option value="">Selecione...</option>
                                    {unidadesPermitidas.map((idx) => (
                                        <option key={idx} value={idx.toString().padStart(2, '0')}>{unidades[idx]}</option>
                                    ))}
                                </Form.Select>
                            </div>

                            <div className="col-md-3">
                                <Form.Label>Status da Carteirinha</Form.Label>
                                <Form.Select
                                    value={statusFiltro}
                                    onChange={(e) => setStatusFiltro(e.target.value)}
                                >
                                    <option value="TODOS">Todos os Status</option>
                                    <option value="Conferida e usada">Conferida e usada</option>
                                    <option value="Conferida mas nunca usada">Conferida mas nunca usada</option>
                                    <option value="Inconsistência: Uso sem conferência">Uso sem conferência</option>
                                    <option value="Pedido em aberto (Não entregue)">Pedido em aberto</option>
                                    <option value="Sem registro de pedido no sistema">Sem pedido no sistema</option>
                                </Form.Select>
                            </div>

                            <div className="col-md-3">
                                <Form.Label>Pesquisar Aluno/Turma</Form.Label>
                                <Form.Control
                                    placeholder="Nome ou Matrícula..."
                                    value={buscaTexto}
                                    onChange={(e) => setBuscaTexto(e.target.value)}
                                />
                            </div>

                            <div className="col-md-3 d-flex align-items-end gap-2">
                                <Button variant="primary" className="flex-grow-1" onClick={() => handleBuscar()} disabled={loading}>
                                    {loading ? '...' : 'Atualizar'}
                                </Button>
                                <Button variant="outline-secondary" onClick={() => { setBuscaTexto(""); setStatusFiltro("TODOS") }}>
                                    Limpar
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            <div className="table-responsive shadow-sm" style={{ maxHeight: '60vh', overflowY: 'auto', borderRadius: '8px' }}>
                <Table striped bordered hover size="sm" className="bg-white mb-0">
                    <thead className="table-dark sticky-top">
                        <tr>
                            <th>Matrícula</th>
                            <th>Nome</th>
                            <th className="text-center">Turma</th>
                            <th className="text-center">Último Pedido</th>
                            <th className="text-center">Último Uso</th>
                            <th className="text-center">Diagnóstico</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dadosFiltrados.map((item, index) => (
                            <tr key={index}>
                                <td className="align-middle">{item.matricula}</td>
                                <td className="align-middle">{item.nome}</td>
                                <td className="text-center align-middle">{item.turma}</td>
                                <td className="text-center align-middle">{item.ultimo_pedido}</td>
                                <td className="text-center align-middle">{item.ultima_utilizacao}</td>
                                <td className="text-center align-middle">{getStatusBadge(item.status_final)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <footer className="fixed-bottom bg-dark text-white p-2 shadow-lg">
                <div className="container-fluid d-flex justify-content-between align-items-center">
                    <small>Filtrando {dadosFiltrados.length} de {listaAlunos.length} alunos</small>
                    <span>Unidade: <strong>{unidades[parseInt(unidadeFiltro)] || '---'}</strong></span>
                </div>
            </footer>
        </div>
    );
}

export default PenteFinoCarteirinhas;